var _ = require('underscore');
module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div>\n    <div id="notifications-header" class="notifications-header">\n        <h1 class="notifications-title">Notifications</h1>\n        <button class="btn btn-sm btn-clearNotifications">Clear all</button>\n    </div>\n    <div id="notifications-list" class="notifications-list"></div>\n</div>';
}
return __p;
};
